import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import React from 'react'

import Loading from '@/app/component/guard/loading'
import { ERROR_GET_CAMPAIGN_ITEM_SERVER } from '@/app/module/campaigns/definitions'
import { useGetCampaign } from '@/app/module/campaigns/hooks/use-get-campaign'
import { useOrgSwitchGuard } from '@/app/module/campaigns/utils/campaign'
import { getErrorMessage } from '@/app/store/api'
import { type CountryTimezone, type LoadingError, type Timezones } from '@/app/types'

import Subscriptions from '../subscriptions'

const getErrorStatus = (errorValue: unknown) => {
  if (!errorValue || typeof errorValue !== 'object' || !('status' in errorValue)) {
    return undefined
  }

  const status = (errorValue as { status?: number }).status
  return typeof status === 'number' ? status : undefined
}

type Props = {
  countriesTimezones: CountryTimezone[]
  countryCode: string
  itemId: number
  orgId: number
  timezone: string
  timezones: Timezones
}

const CampaignManage: React.FC<Props> = (props) => {
  const { itemId } = props
  const { data: item, error: campaignError, isFetching, isLoading } = useGetCampaign(itemId)
  const itemTitle = item?.name ? `for "${item.name}"` : ''
  const showLoading = isLoading || (isFetching && !item)
  const errorMessage = campaignError ? getErrorMessage(campaignError, ERROR_GET_CAMPAIGN_ITEM_SERVER) : undefined
  const error: LoadingError | undefined = errorMessage
    ? {
        status: getErrorStatus(campaignError),
        message: errorMessage,
      }
    : undefined

  useOrgSwitchGuard(props.orgId)

  return (
    <Loading isLoading={showLoading} error={error}>
      <Box sx={{ px: { xs: 2, md: 0 } }}>
        <Typography sx={{ p: { md: 2 }, py: 2 }} variant="h6">
          Manage subscriptions {itemTitle}
        </Typography>
        <Subscriptions {...props} item={item} />
      </Box>
    </Loading>
  )
}

export default React.memo(CampaignManage)
